import MkuSwitch from './src/switch';

MkuSwitch.install = function (Vue) {
  Vue.component(MkuSwitch.name, MkuSwitch);
};

export default MkuSwitch;
